import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';
import { z } from 'zod';

export const loginFromTokenRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/from_token',
  validateSearch: z.object({
    sign_in_token: z.string().optional(),
  }),
}).lazy(() => import('pages/shared/Login/FromToken/FromToken').then((d) => d.Route));
